import { AlertDialog, AlertDialogBody, AlertDialogContent, AlertDialogFooter, AlertDialogOverlay, Button, Input } from "@chakra-ui/react";
import { ChangeEvent, useRef, useState } from "react";
import { setFocusLocked } from "../../Store/GlobalReducer";
import { useAppDispatch } from "../../Store/hooks";
import { colors } from "../../Theme";

const GroupElements = (props: { handleGroup: (name: string) => void }) => {
  const [isOpen, setIsOpen] = useState(false);
  const cancelRef = useRef<HTMLButtonElement>(null);

  const [name, setName] = useState("");

  const dispatch = useAppDispatch();

  const onClose = () => {
    setName("");
    setIsOpen(false);
    dispatch(setFocusLocked(false));
  };

  const onOpen = () => {
    setIsOpen(true);
    dispatch(setFocusLocked(true));
  };

  const handleSave = () => {
    props.handleGroup(name);
    onClose();
  };
  return (
    <>
      <Button isFullWidth variant="editor" onClick={onOpen}>
        Группировать
      </Button>

      <AlertDialog
        isOpen={isOpen}
        leastDestructiveRef={cancelRef}
        onClose={onClose}
        isCentered
      >
        <AlertDialogOverlay>
          <AlertDialogContent bg={colors.badgeLight}>
            <AlertDialogBody>
              <form onSubmit={handleSave}>
                Укажите название группы
                <Input
                  fontSize="1.5rem"
                  variant="editor"
                  value={name}
                  placeholder="Название"
                  onChange={(ev: ChangeEvent<HTMLInputElement>) =>
                    setName(ev.target.value)
                  }
                />
              </form>
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={onClose} variant="editor">
                Отмена
              </Button>
              <Button variant="editor" onClick={handleSave} ml={3}>
                Сохранить
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </>
  );
};

export default GroupElements;
